import { NextSeo } from 'next-seo';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const LibrariansSeo: FC = () => {
  const { t } = useTranslation();

  return (
    <NextSeo
      title="A digital library of groundbreaking research"
      description="More than 55,000 curated and aggregated videos of lectures and presentations from top scientific and medical conferences. Multidisciplinary coverage of physical, material and health sciences, social sciences, and humanities."
      openGraph={{
        title: 'A digital library of groundbreaking research',
        url: `${process.env.NEXT_PUBLIC_BASE_URL}/librarians`,
      }}
    />
  );
};
